import styles from './PageProductSignInLink.module.css';
import LinkAuthFlow from './LinkAuthFlow.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import deriveProductFromProductSku from '../utils/deriveProductFromProductSku.js';

function PageProductSignInLink({ isMobile }) {
  const { productSku } = useSearchParamOrDefaultProps();
  return (
    <div
      className={classNames(styles.signIn, {
        [styles.mobileSignIn]: isMobile,
        [styles.heroSignIn]: !isMobile,
      })}
    >
      <span>Already a subscriber?</span>
      <LinkAuthFlow
        className={styles.signInButton}
        product={deriveProductFromProductSku(productSku)}
        modalType={'signIn'}
        letterSpacing={'normal'}
        contentType={'livestream'}
      >
        <span
          className={classNames(styles.signInLink, {
            [styles.mobileSignInLink]: isMobile,
            [styles.heroSignInLink]: !isMobile,
          })}
        >
          Sign in
        </span>
      </LinkAuthFlow>
    </div>
  );
}

PageProductSignInLink.propTypes = {
  isMobile: PropTypes.bool,
};

export default PageProductSignInLink;
